import { toast } from 'react-toastify'
import { get, post } from 'src/apis/apiService'
import { AUTH_APIS } from 'src/apis/authApi'
import { firebaseLogout } from 'src/utils/logoutStatus'
import config from '../config'
import { firebaseAuth } from '../firebaseConfig'
import { handleDeviceSession } from '../utils/sessionHelper'
import Axios from 'axios'

const LOGIN_REQUEST = 'LOGIN_REQUEST'
const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
const LOGIN_FAILURE = 'LOGIN_FAILURE'
const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
const SET_COUNTRY = 'SET_COUNTRY'

export interface CurrentUserType {
  id: string
  role: string
  email: string
  [key: string]: any
}

export interface LoginCredentialsTypes {
  email: string
  password: string
}

export interface SsoCredentialsType {
  sso_token: string
}

export const ATTENDANCE_NOTICE_FLAG = 'showAttendanceNotice'

/**** Initial States ****/

const initialState = {
  appReady: false,
  isFetching: false,
  isSsoLoading: true,
  isAuthenticated: localStorage.getItem('jwt_token') ? true : false,
  currentUser: {},
  countryCode: ""
}

/**** Reducers ****/

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        isFetching: true,
        isAuthenticated: false,
      }

    case LOGIN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: true,
        currentUser: action.user,
        appReady: true,
        isSsoLoading: false,
      }

    case LOGIN_FAILURE:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: false,
        isSsoLoading: false,
      }

    case LOGOUT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: false,
        currentUser: {},
      }

    case SET_COUNTRY:
      return {
        ...state,
        countryCode: action.countryCode,
      }
    default:
      return state
  }
}

/**** Actions ****/

export function refreshUser(dispatch) {
  get(
    AUTH_APIS.autoLogin,
    (data, status) => {
      if (status === 200 && data.success) {
        dispatch(receiveLogin(data.user))
      } else {
        dispatch(rejectLogin())
      }
    },
    (error) => {
      dispatch(rejectLogin())
      console.error('Error: ', error)
    }
  )
}

export function loginUser(dispatch, history, credentials?: LoginCredentialsTypes | SsoCredentialsType, ssoLogin?: boolean) {
  dispatch(requestLogin())
  const loginEndpoint = ssoLogin ? `${config.apiUrl}/api/sso_login` : `${config.apiUrl}/api/login`
  post(
    loginEndpoint,
    async (data, status) => {
      if (status === 200 && data.success) {
        
        const { user: firebaseUser } = await firebaseAuth.signInWithCustomToken(data.firebaseToken)
        // Because we are not setting up a dev env firebase db
        // we do not want to set user's email in Firebase if the log in
        // is happening on development environment to prevent email unique constraint error
        if (process.env.NODE_ENV === 'production') firebaseUser.updateEmail(data.user.email)
        handleDeviceSession(data.user.id)
        localStorage.setItem('jwt_token', data.token)
        // Consumed by the Lobby pages to show the attendance reminder once per
        // login (not on every refresh, which also goes through receiveLogin).
        sessionStorage.setItem(ATTENDANCE_NOTICE_FLAG, '1')
        dispatch(receiveLogin(data.user, `Hello ${data.user.fullName}, welcome to ${config.eventName}!`))
        console.info('Firebase: ', firebaseUser.email)
      } else {
        dispatch(rejectLogin(data.error.response?.data?.message))
      }
    },
    (error) => {
      console.log(error.response)
      dispatch(rejectLogin(error.response?.data?.message))
      console.error('Error: ', error)
    },
    credentials
  )
}

const clearUserSession = () => {
  localStorage.removeItem('jwt_token')
  localStorage.removeItem('session_token')
  localStorage.removeItem('node')
  localStorage.removeItem('shouldLogout')
  sessionStorage.removeItem(ATTENDANCE_NOTICE_FLAG)
}

export function logoutUser(dispatch, currentUser: CurrentUserType, currentPagePath: string, message: string) {
  firebaseLogout(currentUser, currentPagePath)
  firebaseAuth
    .signOut()
    .then(() => {
      clearUserSession()
      dispatch(receiveLogout(message))
    })
    .catch((error) => {
      console.error(error)
    })
}

function requestLogin() {
  return {
    type: LOGIN_REQUEST,
  }
}

function receiveLogin(user, message?: string) {
  if (message) toast(message, { toastId: message })
  return {
    type: LOGIN_SUCCESS,
    user,
  }
}

function rejectLogin(message?: string) {
  if (message) toast.error(message)
  return {
    type: LOGIN_FAILURE,
  }
}

function receiveLogout(message?: string) {
  if (message) toast(message, { toastId: 'receiveLogoutToast' })
  return {
    type: LOGOUT_SUCCESS,
  }
}

function setIPCountry(countryCode: string) {
  return {
    type: SET_COUNTRY,
    countryCode
  }
}